import React from 'react';
import { gql } from '@soundxyz/gql-string';
import {
  ArtistsBackedModal,
  CollectedModal,
  CollectorMintsModal,
} from '@components/modals/UserStats';
import { FollowersFollowingModal } from '@components/modals/UserStats/FollowersFollowing';
import { ModalContext, ModalType } from '@context/modal';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, UserStatsFragmentDoc } from '@graphql/reactQuery';
import { StatsInfo } from './components/StatsInfo';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment UserStats on User {
    id
    followerCount
    followingCount
    numBackedArtists
    nftsOwned
    artist {
      id
      numCollectors
      numNfts
      ...ArtistCollectorsMintInfo
    }
    ...FollowersFollowingModal
    ...CollectedUserStatModal
    ...UserArtistBackedInfo
  }
`);

export const UserStats = ({
  statsData,
  loading,
}: {
  statsData: FragmentType<UserStatsFragmentDoc>;
  loading?: boolean;
}) => {
  const userInfo = getFragment(UserStatsFragmentDoc, statsData);
  const { followerCount, numBackedArtists, nftsOwned, artist } = userInfo;
  const { openModal } = ModalContext.useContainer();
  const isArtist = !!artist;

  return (
    <div className="flex gap-5 pt-1 md:gap-8 ">
      <StatsInfo
        loading={loading}
        total={followerCount}
        label="Followers"
        onClick={() => {
          openModal(ModalType.FOLLOWERS_FOLLOWING, {
            body: <FollowersFollowingModal followData={userInfo} />,
          });
        }}
      />

      {isArtist && (
        <>
          <StatsInfo
            loading={loading}
            total={artist.numNfts ?? 0}
            label="Mints"
            onClick={() => {
              openModal(ModalType.ARTIST_COLLECTORS_MINTS, {
                body: <CollectorMintsModal artistData={artist} />,
              });
            }}
          />
          <StatsInfo
            loading={loading}
            total={artist.numCollectors ?? 0}
            label="Collectors"
            onClick={() => {
              openModal(ModalType.ARTIST_COLLECTORS_MINTS, {
                body: <CollectorMintsModal artistData={artist} variant="collectors" />,
              });
            }}
          />
        </>
      )}

      <StatsInfo
        loading={loading}
        total={nftsOwned}
        label="Collected"
        onClick={() => {
          openModal(ModalType.ARTIST_COLLECTORS_MINTS, {
            body: <CollectedModal userCollectedData={userInfo} />,
          });
        }}
      />

      {!isArtist && (
        <StatsInfo
          loading={loading}
          total={numBackedArtists}
          label="Artist Backed"
          onClick={() => {
            openModal(ModalType.ARTISTS_BACKED, {
              body: <ArtistsBackedModal userData={userInfo} />,
            });
          }}
        />
      )}
    </div>
  );
};
